export default __webpack_public_path__ + "static/media/text_nav.044ca786.svg";